import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { ConversionUtils } from "turbocommons-ts";
import { MatSnackBar } from "@angular/material/snack-bar";
import { OptionForSynthese } from "../tools/ui/selection-category-synthese-chantier/option-for-synthese";

@Injectable({
    providedIn: 'root',
})
export class DocumentService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/document`;

    private GSServiceUrl = `${environment.GSServiceBaseUrl}api/document`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    createDocument(files: File[]) {

        const formData: FormData = new FormData();

        formData.append('email', 'test@test.com');
        files.forEach(file => {
            formData.append('files', file, file.name);
        });

        return this.http.request(new HttpRequest('POST', `${this.serviceUrl}/order`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('createDocument')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }

    createPDRE(files: File[]) {

        const formData: FormData = new FormData();

        files.forEach(file => {
            formData.append('file', file, file.name);
        });

        return this.http.request(new HttpRequest('POST', `${this.serviceUrl}/pdre`, formData, this.generateHeaderForFormData()))
            .pipe(
                catchError(this.handleError<any>('createPDRE')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }

    deleteDocument(fileName: string) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${encodeURI(fileName)}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getStrategyById')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getAreaMapFileBySampingId(samplingId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/areamap/${samplingId}`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getAreaMapFileBySampingId')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getPropositionReport(strategyId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${strategyId}/proposition`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getPropositionReport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getFinalReport(strategyId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${strategyId}/finalreport`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getFinalReport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getElimsReport(samplingId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/analyticalReport/${samplingId}`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getElimsReport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getSyntheseChantier(strategyId: number, options: OptionForSynthese) {
        this.loadingTask.activateLoading();

        return this.http.put(`${this.serviceUrl}/${strategyId}/syntheseChantier`, options, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getSyntheseChantier')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    // Get Area Map from GS
    getMapImage(areaMapName: string, strategyId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/areamap/${strategyId}/${encodeURI(ConversionUtils.stringToBase64(areaMapName))}/base64`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMapImage')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: any) => {
                return response;
            }));
    }

    getResultExport(strategyId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${strategyId}/export/result`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getResultExport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getMeasureOPExport(year: number, month: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/export/op/${year}/${month}`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getMeasureOPExport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    getReportListForStrategy(strategyId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.GSServiceUrl}/AnalyticalReport/bystrategy/${strategyId}`, this.generateHeaderForFileDownload(environment.GSBearer)).pipe(
            catchError(this.handleError<any>('getReportListForStrategy')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}